import React, { useState } from 'react';
import './ProjectSlider.css';
import Button from './Button';
import FsLightbox from 'fslightbox-react';
import { getFullImageUrl } from '../utils/apiBase';

const ProjectSlider = ({projectimages}) => {   
    const [toggler, setToggler] = useState(false); 
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 rounded-xl overflow-hidden property-images w-full relative'>
            {projectimages.map((projectimg)=>(
            <div className='property-image' key={projectimg.id}>
                <div className='property-img-holder' style={{backgroundImage:`url('${getFullImageUrl(projectimg.img)}')`}}  onClick={() => setToggler(!toggler)}></div>
            </div>
            ))}
            <div className='absolute right-4 bottom-4'>
                <Button type='button' variant='flowless' className='hover:bg-sky-950 hover:border-transparent hover:text-white font-bold rounded-lg' onClick={() => setToggler(!toggler)}>See All Photos</Button>
            </div>
            <FsLightbox
				toggler={toggler}
				sources={projectimages.map((projectimg)=>(
                    <img key={projectimg.id} src={getFullImageUrl(projectimg.img)} alt={projectimg.alttext} />
                ))}
                disableLocalStorage={true}
                key={ projectimages }
			/>
        </div>
    );
}

export default ProjectSlider;